<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="预委托编号" prop="entrustNum">
            <el-input v-model="form.entrustNum" placeholder="请输入预委托编号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电梯识别码" prop="OIDNO">
            <el-input v-model="form.OIDNO" placeholder="请输入电梯识别码" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="使用单位名称" prop="USE_UNT_NAME">
            <el-input v-model="form.USE_UNT_NAME" placeholder="请输入使用单位名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备使用地点" prop="EQP_USE_ADDR">
            <el-input v-model="form.EQP_USE_ADDR" placeholder="请输入设备使用地点" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备名称" prop="EQP_NAME">
            <el-input v-model="form.EQP_NAME" placeholder="请输入设备名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出厂编号" prop="FACTORY_COD">
            <el-input v-model="form.FACTORY_COD" placeholder="请输入出厂编号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="单位内编号" prop="EQP_INNER_COD">
            <el-input v-model="form.EQP_INNER_COD" placeholder="请输入单位内编号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一信用代码" prop="USE_UNT_COD">
            <el-input v-model="form.USE_UNT_COD" placeholder="请输入统一信用代码" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备品种" prop="EQP_VART_NAME">
            <el-input v-model="form.EQP_VART_NAME" placeholder="请输入设备品种" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备安装地点" prop="EQP_AREA_NAME">
            <el-input v-model="form.EQP_AREA_NAME" placeholder="请输入设备安装地点" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品型号" prop="EQP_MOD">
            <el-input v-model="form.EQP_MOD" placeholder="请输入产品型号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用登记证号" prop="EQP_USECERT_COD">
            <el-input v-model="form.EQP_USECERT_COD" placeholder="请输入使用登记证号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="制造单位名称" prop="MAKE_UNT_NAME">
            <el-input v-model="form.MAKE_UNT_NAME" placeholder="请输入制造单位名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="制造日期" prop="MAKE_DATE">
            <el-date-picker v-model="form.MAKE_DATE" type="date" placeholder="请选择制造日期" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="改造单位名称" prop="renovation_unt_name">
            <el-input v-model="form.renovation_unt_name" placeholder="请输入改造单位名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="改造日期" prop="renovation_date">
            <el-date-picker v-model="form.renovation_date" type="date" placeholder="请选择改造日期" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="维保单位名称" prop="service_unt_name">
            <el-input v-model="form.service_unt_name" placeholder="请输入维保单位名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="安管人员" prop="SAFE_MEN">
            <el-input v-model="form.SAFE_MEN" placeholder="请输入安管人员" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="额定载重量(kg)" prop="RATEDLOAD">
            <el-input-number v-model="form.RATEDLOAD" :min="0" placeholder="请输入额定载重量" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电梯层数" prop="ELEFLOORNUMBER">
            <el-input-number v-model="form.ELEFLOORNUMBER" :min="1" placeholder="请输入电梯层数" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="额定速度(m/s)" prop="RATEDVELOCITY">
            <el-input-number v-model="form.RATEDVELOCITY" :min="0" :precision="2" placeholder="请输入额定速度" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="控制方式" prop="CONTROL_TYPE">
            <el-input v-model="form.CONTROL_TYPE" placeholder="请输入控制方式" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备代码" prop="EQP_STATION_COD">
            <el-input v-model="form.EQP_STATION_COD" placeholder="请输入设备代码" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="记录编号" prop="recordNum">
            <el-input v-model="form.recordNum" placeholder="请输入记录编号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="电梯站数" prop="ELESTADENUMBER">
            <el-input-number v-model="form.ELESTADENUMBER" :min="1" placeholder="请输入电梯站数" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电梯门数" prop="ELEDOORNUMBER">
            <el-input-number v-model="form.ELEDOORNUMBER" :min="1" placeholder="请输入电梯门数" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备类别" prop="EQP_SORT_NAME">
            <el-input v-model="form.EQP_SORT_NAME" placeholder="请输入设备类别" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退回原因" prop="backReason">
            <el-input v-model="form.backReason" type="textarea" placeholder="请输入退回原因" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryTestData, saveTestData, } from '@/api/contract/contract';

export default {
  name: 'OriginalManagementAddAndEdit',
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      loading: false,
      form: {
        id: undefined,
        entrustNum: '',
        OIDNO: '',
        USE_UNT_NAME: '',
        EQP_USE_ADDR: '',
        EQP_NAME: '',
        FACTORY_COD: '',
        EQP_INNER_COD: '',
        USE_UNT_COD: '',
        EQP_VART_NAME: '',
        EQP_AREA_NAME: '',
        EQP_MOD: '',
        EQP_USECERT_COD: '',
        MAKE_UNT_NAME: '',
        MAKE_DATE: '',
        renovation_unt_name: '',
        renovation_date: '',
        service_unt_name: '',
        SAFE_MEN: '',
        RATEDLOAD: undefined,
        ELEFLOORNUMBER: undefined,
        RATEDVELOCITY: undefined,
        CONTROL_TYPE: '',
        EQP_STATION_COD: '',
        recordNum: '',
        ELESTADENUMBER: undefined,
        ELEDOORNUMBER: undefined,
        EQP_SORT_NAME: '',
        backReason: ''
      },
      rules: {
        entrustNum: [
          { required: true, message: '请输入预委托编号', trigger: 'blur' }
        ],
        OIDNO: [
          { required: true, message: '请输入电梯识别码', trigger: 'blur' }
        ],
        USE_UNT_NAME: [
          { required: true, message: '请输入使用单位名称', trigger: 'blur' }
        ],
        EQP_USE_ADDR: [
          { required: true, message: '请输入设备使用地点', trigger: 'blur' }
        ],
        EQP_NAME: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        FACTORY_COD: [
          { required: true, message: '请输入出厂编号', trigger: 'blur' }
        ],
        MAKE_UNT_NAME: [
          { required: true, message: '请输入制造单位名称', trigger: 'blur' }
        ],
        RATEDLOAD: [
          { required: true, message: '请输入额定载重量', trigger: 'blur' }
        ],
        ELEFLOORNUMBER: [
          { required: true, message: '请输入电梯层数', trigger: 'blur' }
        ],
        RATEDVELOCITY: [
          { required: true, message: '请输入额定速度', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 打开弹窗
    openDialog (type, row = {}) {
      this.dialogType = type;
      this.dialogTitle = type === 'Add' ? '新增原始记录' : '修改原始记录';
      this.dialogVisible = true;

      // 重置表单
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        if (type === 'Edit' && row) {
          // 编辑模式下，调用 API 获取详细数据
          if (row.entrustNum) {
            this.loading = true;
            queryTestData(row.entrustNum).then(res => {
              if (res.retCode === 'ok' && res.data) {
                this.form = { ...res.data };
              } else {
                // 如果 API 调用失败，使用传入的 row 数据
                this.form = { ...row };
              }
            }).catch(error => {
              console.error('获取详细数据失败:', error);
              this.$message.warning('获取详细数据失败，使用基础数据');
              // 如果 API 调用失败，使用传入的 row 数据
              this.form = { ...row };
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.form = { ...row };
          }
        } else {
          this.form = {
            id: undefined,
            entrustNum: '',
            OIDNO: '',
            USE_UNT_NAME: '',
            EQP_USE_ADDR: '',
            EQP_NAME: '',
            FACTORY_COD: '',
            EQP_INNER_COD: '',
            USE_UNT_COD: '',
            EQP_VART_NAME: '',
            EQP_AREA_NAME: '',
            EQP_MOD: '',
            EQP_USECERT_COD: '',
            MAKE_UNT_NAME: '',
            MAKE_DATE: '',
            renovation_unt_name: '',
            renovation_date: '',
            service_unt_name: '',
            SAFE_MEN: '',
            RATEDLOAD: undefined,
            ELEFLOORNUMBER: undefined,
            RATEDVELOCITY: undefined,
            CONTROL_TYPE: '',
            EQP_STATION_COD: '',
            recordNum: '',
            ELESTADENUMBER: undefined,
            ELEDOORNUMBER: undefined,
            EQP_SORT_NAME: '',
            backReason: ''
          };
        }
      });
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false;
      this.loading = false;
    },
    // 提交表单
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const apiCall = this.dialogType === 'Add' ? saveTestData : saveTestData;

          apiCall(this.form).then(res => {
            if (res.retCode === 'ok') {
              this.$message.success(this.dialogType === 'Add' ? '新增成功' : '修改成功');
              this.handleClose();
              this.$emit('refresh');
            }
          }).catch(error => {
            console.error('操作失败:', error);
            this.$message.error('操作失败');
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>

